export const LoginCategory: string = 'Login Header';
export const LoginClickedAction: string = 'Login Header: Clicked';
